import { createGlobalStyle } from "styled-components";
import { mq } from "./mq";
import { theme } from "./theme";

export const GlobalStyle = createGlobalStyle`
@font-face {
  font-family: "Skolar Sans PE condensed";
  src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff2")
      format("woff2"),
    url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff")
      format("woff");
  font-weight: 400;
  font-style: normal;
}
/*@font-face {
  font-family: "Skolar Sans PE condensed";
  src: url("https://stdatavisualpublic001.blob.core.windows.net/uk-war-timeline/fonts/RFESkolarSansPECnWeb-Eb.woff2")
    format("woff2");
  font-weight: 800;
  font-style: normal;
}*/
@font-face {
  font-family: "Skolar PE";
  src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Regular_v3.5.woff2") format("woff2"), url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Regular_v3.5.woff") format("woff");
  font-weight: 400;
  font-style: normal;
  }

  @font-face {
    font-family: "Skolar PE";
    src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Italic_v3.5.woff2") format("woff2"), url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Italic_v3.5.woff") format("woff");
    font-weight: 400;
    font-style: italic;
    }

:root {
  --text-color: ${theme.colors.text};
  --text-highlited: ${theme.colors.highlighted_text};
  --background-color: ${theme.colors.background};
};
* {
  box-sizing: border-box;
}
html {
  font-size: 62.5%;
  //scroll-behavior: smooth;
}
body {
  font-family: "Skolar Sans PE condensed";
  font-size: 1.6rem;
  margin: 0;
  padding: 0;
  color: ${theme.colors.text};
  background-color: ${theme.colors.background};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`;
